import { useEffect } from 'react'
import { useInitializer } from '@/hooks/useInitializer'
import { useReduxState } from '@/hooks/reduxState'
import { redirectWithReturnUrl } from '@/components/auth/authProvider'

const Initializer = ({ children }) => {
  const [signedIn, institutionSelected] = useReduxState(state => [
    !!state.identity.signedIn,
    !!(state.identity.user && state.identity.user.profile && state.identity.user.profile.InstitutionId)
  ])
  const { isAnonymousPath } = useInitializer()
  useEffect(() => {
    if (signedIn && !isAnonymousPath && !institutionSelected) {
      redirectWithReturnUrl('/login/institution')
    }
  }, [isAnonymousPath, institutionSelected, signedIn])
  return children
}

export default Initializer



// WEBPACK FOOTER //
// ./src/report-app/initializer.js